const API_KEY = 'AIzaSyBmQN8XKCc4HqAjKbW0kqJfyFz6p-t-Shc'

export default API_KEY;
